import GroupListTable from "./groupListTable.container";

export default GroupListTable;
